export default __webpack_public_path__ + "static/business-details-e01654cb9dbdc7ff2f91a54e48daa4f5.webp";